import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/fr'

export default class CustomDateAdapter extends AdapterDayjs {
	getWeekdays = (): string[] => {
		const start = this.dayjs().locale('fr').startOf('week')
		return [0, 1, 2, 3, 4, 5, 6].map((diff) =>
			this.formatByString(start.add(diff, 'day'), 'ddd')
		)
	}
}